"use client";
import { useProgressContext } from "./use-progress-context.js";
//#region src/components/progress/progress-context.tsx
var ProgressContext = (props) => props.children(useProgressContext());
//#endregion
export { ProgressContext };
